import { ServiceMaker } from "./index";

const fetchImage = (data:string) =>
  ServiceMaker(`verification/signedURL/${data}`, "GET");

export default fetchImage;
